// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__eqaD4","icon":"styles_icon__TJQCG","input":"styles_input__ApP5l","disabled":"styles_disabled__OQy8g"};